export default function SettingsDialogController(
  $q,
  $rootScope,
  $scope,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  riskSharedModelService,
  editRiskTypeDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleShowAddRiskTypeClick = _handleShowAddRiskTypeClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
  }

  // Expand/Collapse
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.settingControlDialog);
  }

  function _handleShowAddRiskTypeClick($event) {
    const risk = { customerRiskTypeId: 0 };
    riskDataService.getRiskTypeDefaults().then((response) => {
      risk.riskOnset = response.data.riskOnset;
      risk.riskForewarning = response.data.riskForewarning;
      risk.riskDuration = response.data.riskDuration;
      risk.riskDataConfidentiality = response.data.riskDataConfidentiality;
      risk.riskDataIntegrity = response.data.riskDataIntegrity;
      risk.riskDataAvailability = response.data.riskDataAvailability;
      risk.riskDirection = response.data.riskDirection;
      risk.riskTrending = response.data.riskTrending;
      risk.riskAssessmentFrequency = response.data.riskAssessmentFrequency;
      risk.riskProbability = response.data.riskProbability;
      risk.riskClassification = response.data.riskClassification;
      ssDialogService.dialogs.riskAdmin.editRiskTypeDialog = ssDialogService.alert(
        editRiskTypeDialog.getOptions($event, {
          risk,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskTypeDialog);
    });
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshRiskTypes',
      _refreshRiskTypes
    );
  }

  function _refreshRiskTypes() {
    const dfdItem = $q.defer();
    riskDataService.getRiskTypes().then((response) => {
      vm.riskTypeList = response.data.result;
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }
}

SettingsDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'riskSharedModelService',
  'editRiskTypeDialog',
];
